module.exports = __webpack_public_path__ + "static/media/Snowflake.22a97be1.png";